import {
  defineElement,
  ElementDefinition,
} from '@amzn/exs-elements/web-component';
import serverDefinition from './definition';
import { getWebVitalsPlugin } from '../../common/webvitals-plugin';
import { getLumberjackPlugin } from '../../common/lumberjack-plugin';
import { ExsElementsHydrationPlugin } from '@amzn/exs-gem-react/plugins';
import { ExsElementsEspAdapterPlugin } from '@amzn/exs-esp-adapters/plugins';
import { ClickstreamPlugin, FontEmbedPlugin } from '@amzn/exs-elements/plugins';
import { amazonCartDefinition } from '../../amazon-cart/v1.0/web-component';
import { sharedClickstreamDimensions } from '../../common/settings';

export const amazonPurchaseButtonDefinition: ElementDefinition = {
  ...serverDefinition,
  plugins: [
    getWebVitalsPlugin(serverDefinition.tagName),
    getLumberjackPlugin(serverDefinition.tagName),
    ClickstreamPlugin({
      elementTagName: serverDefinition.tagName,
      ...sharedClickstreamDimensions,
    }),
    ExsElementsHydrationPlugin({
      /**
       * this is the compiled version of
       * src/elements/amazon-purchase-button/entry-client.ts
       *
       * you can find it under
       * dist/assets/elements/amazon-purchase-button/entry-client.js
       */
      clientEntryPath: '/elements/amazon-purchase-button/v1.0/entry-client.js',
    }),
    ExsElementsEspAdapterPlugin({
      quantityChangeEnabled: true,
      subscribeAndSaveEnabled: true,
      enableHelperByDefault: true,
    }),
    FontEmbedPlugin({
      fonts: [
        {
          vendor: 'Amazon',
          family: 'Amazon Ember',
        },
      ],
    }),
  ],
};

defineElement(amazonPurchaseButtonDefinition);

defineElement(amazonCartDefinition);
